/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon16Solid = forwardRef('NetCloudWireIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.037 4.187a4.25 4.25 0 0 1 8.088-1.185L11.25 3a4.5 4.5 0 1 1 0 9H9v2h4a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h4v-2H4.25a4 4 0 0 1-1.213-7.813Z" })));
});
